// extracted by mini-css-extract-plugin
export default {"profile-relation":"Badge_profile-relation__rbkkU","beige":"Badge_beige__I3Wzv","green":"Badge_green__ht1d5","blue":"Badge_blue__QJHXX","purple":"Badge_purple__0ok+z"};